import axios from "axios";
import { API } from "../lib/api";

export { API };
export const TOKEN_KEY = "repairro_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminAxios = axios.create({ baseURL: `${API}/admin` });

adminAxios.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

adminAxios.interceptors.response.use(
  (r) => r,
  (err) => {
    // On 401, drop the token so ProtectedRoute kicks back to /admin/login.
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatErr = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return err?.message || "Something went wrong";
};
